// import { headerVisible } from "../include/module";
import { headerToggle } from "../include/module";
import { newsTile } from "../include/module";
import { artistTile } from "../include/module";
import { anchorLink } from "../include/module";





(() => {

  // ------------------------------------------------------------------------
  // headerVisible
  // -> SP ヘッダー出現
  // ------------------------------------------------------------------------
  // headerVisible();

  // ------------------------------------------------------------------------
  // headerToggle
  // -> SP ヘッダー開閉
  // ------------------------------------------------------------------------
  headerToggle();

  // ------------------------------------------------------------------------
  // newsTile
  // -> NEWSタイトル 高さ調整
  // ------------------------------------------------------------------------
  newsTile();

  // ------------------------------------------------------------------------
  // artistTile
  // -> ARTIST名前 高さ調整
  // ------------------------------------------------------------------------
  artistTile();

  // ------------------------------------------------------------------------
  // anchorLink
  // -> リンク
  // ------------------------------------------------------------------------
  anchorLink();

  // ------------------------------------------------------------------------
  //
  // -> 汎用変数を定義
  // ------------------------------------------------------------------------
  let windowWidth  = window.innerWidth;
  let windowHeight = window.innerHeight;
  let breakPoint = 750;

  // ------------------------------------------------------------------------
  // indexHeader
  // -> ヘッダーカラーの変更
  // ------------------------------------------------------------------------
  let header = document.getElementById('js-Header');
  window.addEventListener('scroll', () => {
    let scrollHeight = window.pageYOffset;
    if(scrollHeight > 180){
      header.classList.remove('st-Header-White');
      header.classList.add('st-Header-Black');
    } else {
      header.classList.remove('st-Header-Black');
      header.classList.add('st-Header-White');
    }
  }, false);

  // ------------------------------------------------------------------------
  // mainSlider
  // -> 背景画像を設定
  // ------------------------------------------------------------------------
  let sliderThumbnail    = $('.js-Main_Thumbnail');
  let sliderThumbnailUrl = [];
  sliderThumbnail.each(function(index){
    sliderThumbnailUrl.push($(sliderThumbnail[index]).data('thumbnail'));
    $(sliderThumbnail[index]).css('background-image', 'url(' + sliderThumbnailUrl[index] + ')');
  });

  // ------------------------------------------------------------------------
  // mainSlider
  // -> ウィンドウサイズからスライダーの横幅を指定
  // ------------------------------------------------------------------------
  let sliderMinHeight = 735;
  let sliderMaxHeight = 860;

  let sliderMinWidth = 1027;
  let sliderMaxWidth = 1201;

  let sliderWidth     = 0;
  let sliderWidthRate = 0;
  let sliderWidthBase = 0;

  const sliderSetWidth = (currentHeight, resultWidth) => {
    let sliderHeightBase = currentHeight - sliderMinHeight;
    let sliderHeightDifference = sliderMaxHeight - sliderMinHeight;
    let sliderWidthDifference = sliderMaxWidth - sliderMinWidth;
    if (currentHeight < sliderMinHeight) {
      resultWidth = sliderMinWidth;
    } else if (currentHeight > sliderMaxHeight) {
      resultWidth = sliderMaxWidth;
    } else {
      sliderWidthRate = (sliderHeightBase / sliderHeightDifference);
      sliderWidthBase = sliderWidthDifference * sliderWidthRate;
      resultWidth = sliderMinWidth + sliderWidthBase;
    }
    return resultWidth;
  };

  const sliderSet = (currentWidth, resultWidth) => {
    if(currentWidth > breakPoint){
      let sliderObject = $('#js-Main_Slider').bxSlider({
        auto: true,
        speed: 800,
        pause: 8000,
        responsive: true,
        touchEnabled: false,
        slideWidth: resultWidth,
        moveSlides: 1,
        controls: true,
        onSliderLoad: function(index) {
          $($('.idx-Main_Visual_List_Item')[index+1]).find('.Item_Information').addClass('Item_Information-Animate');
          $($('.idx-Main_Visual_List_Item')[index+1]).find('.Item_Information_Curtain').addClass('Item_Information_Curtain-Animate');
          $($('.idx-Main_Visual_List_Item')[index+1]).find('.Item_Information_Base').addClass('Item_Information_Base-Animate');
          setTimeout(function(){
            sliderObject.startAuto();
          }, 1000);
        },
        onSlideBefore: function($slideElement, oldIndex, newIndex){
          $('.idx-Main_Visual_List_Item').find('.Item_Information').removeClass('Item_Information-Animate');
          $('.idx-Main_Visual_List_Item').find('.Item_Information_Curtain').removeClass('Item_Information_Curtain-Animate');
          $('.idx-Main_Visual_List_Item').find('.Item_Information_Base').removeClass('Item_Information_Base-Animate');
        },
        onSlideAfter: function($slideElement, oldIndex, newIndex){
          $slideElement.find('.Item_Information').addClass('Item_Information-Animate');
          $slideElement.find('.Item_Information_Curtain').addClass('Item_Information_Curtain-Animate');
          $slideElement.find('.Item_Information_Base').addClass('Item_Information_Base-Animate');
          sliderObject.startAuto();
        }
      });
    } else {
      let sliderObject = $('#js-Main_Slider').bxSlider({
        auto: true,
        infiniteLoop: true,
        responsive: true,
        speed: 800,
        pager: true,
        controls: false,
        moveSlides: 1,
        pause: 8000,
        oneToOneTouch: true,
        onSliderLoad: function(index) {
          $($('.idx-Main_Visual_List_Item')[index+1]).find('.Item_Information').addClass('Item_Information-Animate');
          $($('.idx-Main_Visual_List_Item')[index+1]).find('.Item_Information_Curtain').addClass('Item_Information_Curtain-Animate');
          $($('.idx-Main_Visual_List_Item')[index+1]).find('.Item_Information_Base').addClass('Item_Information_Base-Animate');
          setTimeout(function(){
            sliderObject.startAuto();
          }, 1000);
        },
        onSlideBefore: function($slideElement, oldIndex, newIndex){
          $('.idx-Main_Visual_List_Item').find('.Item_Information').removeClass('Item_Information-Animate');
          $('.idx-Main_Visual_List_Item').find('.Item_Information_Curtain').removeClass('Item_Information_Curtain-Animate');
          $('.idx-Main_Visual_List_Item').find('.Item_Information_Base').removeClass('Item_Information_Base-Animate');
        },
        onSlideAfter: function($slideElement, oldIndex, newIndex){
          $slideElement.find('.Item_Information').addClass('Item_Information-Animate');
          $slideElement.find('.Item_Information_Curtain').addClass('Item_Information_Curtain-Animate');
          $slideElement.find('.Item_Information_Base').addClass('Item_Information_Base-Animate');
          sliderObject.startAuto();
        }
      });
    }
  };

  sliderSet(windowWidth, sliderSetWidth(windowHeight, sliderWidth));

  window.addEventListener('resize', () => {
    let resizeWidth  = window.innerWidth;
    let resizeHeight = window.innerHeight;
    let resizeSliderWidth = 0;
    sliderSet(resizeWidth, sliderSetWidth(resizeHeight, resizeSliderWidth));
  }, false);



  // ------------------------------------------------------------------------
  // artistImage
  // -> 背景画像を切り替え
  // ------------------------------------------------------------------------
  let artistImage        = $('#js-Artist_Image');
  let artistImageUrl     = [];
  let artistImageItem    = $('.js-Artist_Image_Item');
  let artistSwitchTime   = 6000;
  artistImageItem.each(function(index){
    artistImageUrl.push($(artistImageItem[index]).data('image'));
    $(artistImageItem[index]).css('background-image', 'url(' + artistImageUrl[index] + ')');
  });

  $('#js-Artist_Image li:gt(0)').hide();

  let artistImageAnime = (function(){
    let i = 0;
    let t = artistSwitchTime / 1000 * 60;
    return function() {
      if(i % t === 0){
        $('#js-Artist_Image li:first-child').fadeOut(2000).next('li').fadeIn(2000).end().appendTo('#js-Artist_Image');
      }
      i++;
    };
  })();

  (function artistImageAnimeLoop(){
    artistImageAnime();
    window.requestAnimationFrame(artistImageAnimeLoop);
  })();

  // (function)

  // $(artistImageItem[0]).fadeIn(artistSwitchTime * 0.2).addClass('idx-Artist_Image_List_Item-Animate');
  //
  // setInterval(function(){
  //   let artistImageItemActive = $('.idx-Artist_Image_List_Item-Animate');
  //   let artistImageItemNext   = artistImageItemActive.next('li').length?artistImageItemActive.next('li'):$(artistImageItem[0]);
  //   $(artistImageItemNext).fadeIn(artistSwitchTime * 0.2).addClass('idx-Artist_Image_List_Item-Animate');
  //   $(artistImageItemActive).fadeOut(artistSwitchTime * 0.4).removeClass('idx-Artist_Image_List_Item-Animate');
  // }, artistSwitchTime);



})();



// WEBPACK FOOTER //
// script.js